(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fudge-xHGud-workshop-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-workshop-video]').forEach(function (video) {
    var toggle = video.parentElement.querySelector('[data-sound-toggle]');
    if (!toggle) return;
    toggle.hidden = false;
    toggle.addEventListener('click', function () {
      video.muted = !video.muted;
      var label = toggle.querySelector('[data-sound-label]');
      if (label) label.textContent = video.muted ? 'Sound on' : 'Mute';
      toggle.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
